/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_SpecialistsInputs */

const en_portal_nav_specialists = /** @type {(inputs: Portal_Nav_SpecialistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specialists`)
};

const pl_portal_nav_specialists = /** @type {(inputs: Portal_Nav_SpecialistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specjaliści`)
};

/**
* | output |
* | --- |
* | "Specialists" |
*
* @param {Portal_Nav_SpecialistsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_nav_specialists = /** @type {((inputs?: Portal_Nav_SpecialistsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_SpecialistsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_nav_specialists(inputs)
	return en_portal_nav_specialists(inputs)
});